import React from "react";
import Dropshadow from "../UIResuableComponents/Dropshadow";

import CreateFormDouble from "../UIResuableComponents/CreateForm/CreateFormDouble";
import AdjustForm from "../UIResuableComponents/CreateForm/AdjustForm";
function CreateComponent(props) {
  return (
    <>
      {(props.toggleDropShadow || props.isFromOther) && (
        <>
          {props.needAdjust && props.createOrUpdate === "Update" ? (
            <AdjustForm
              onInputChangeHandler={props.onInputChangeHandler}
              inputFormData={props.inputFormData}
              FormOptions={props.FormOptions}
              onChangeDropShadowHandler={props.onChangeDropShadowHandler}
              CreateName={props.OptionName}
              createOrUpdate={props.createOrUpdate}
              onEditSubmit={props.onEditSubmit}
              onCancelHandler={props.onCancelHandler}
              extraAddBtn={props.extraAddBtn}
              extraButtonText={props.extraButtonText}
              ErrorData={props.ErrorData}
              FormStyle={props.FormStyle}
              NewFormOptions={props.NewFormOptions}
              onDuplicateInputChangeHandler={
                props.onDuplicateInputChangeHandler
              }
              generalDuplicateFormData={props.generalDuplicateFormData}
              OptionNameList={props.OptionNameList}
              adjustedFormStock={props.adjustedFormStock}
              InitialAdjustData={props.InitialAdjustData}
              inputAdjustHandler={props.inputAdjustHandler}
              listForLength={props.listForLength}
              showOtherFormBtn={props.showOtherFormBtn}
              onSubmitAdjustData={props.onSubmitAdjustData}
              onEscPress={props.onEscPress}
            />
          ) : (
            <CreateFormDouble
              setListHandler={props.setListHandler}
              onInputChangeHandler={props.onInputChangeHandler}
              inputFormData={props.inputFormData}
              FormOptions={props.FormOptions}
              onChangeDropShadowHandler={props.onChangeDropShadowHandler}
              CreateName={props.OptionName}
              createOrUpdate={props.createOrUpdate}
              onEditSubmit={props.onEditSubmit}
              onCancelHandler={props.onCancelHandler}
              extraAddBtn={props.extraAddBtn}
              extraButtonText={props.extraButtonText}
              ErrorData={props.ErrorData}
              FormStyle={props.FormStyle}
              NewFormOptions={props.NewFormOptions}
              onDuplicateInputChangeHandler={
                props.onDuplicateInputChangeHandler
              }
              generalDuplicateFormData={props.generalDuplicateFormData}
              OptionNameList={props.OptionNameList}
              onDeleteMultiFieldHandler={props.onDeleteMultiFieldHandler}
              onEscPress={props.onEscPress}
            />
          )}
          <Dropshadow
            onDropDownToggle={props.onChangeDropShadowHandler}
            dropDownStyle="z-20"
            onCancelHandler={props.onCancelHandler}
            createOrUpdate={props.createOrUpdate}
          />
        </>
      )}
    </>
  );
}

export default CreateComponent;
